import React from 'react';
import GlobalWrapper from 'components/global-wrapper/container';
export default function WrapperItems() {
    return (React.createElement(GlobalWrapper, null));
}
